import React from 'react';
import staticMap from './static-mapping';

const getStaticBlock = ({ element, ...block }) => {
    const Component = staticMap[element];
    if (Component) {
        return <Component key={block.id} {...block} />;
    }
    console.warn(`No block found for ${element}`);
    return null;
};

export default getStaticBlock;
